import { render, staticRenderFns } from "./CorporativeIcon.vue?vue&type=template&id=75ee1248&scoped=true&"
import script from "./CorporativeIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CorporativeIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ee1248",
  null
  
)

export default component.exports